// eslint-disable-next-line import/prefer-default-export
export enum ConnectorNames {
  Injected = 'injected',
  WalletConnect = 'walletconnect',
  BSC = 'bsc',
  KLIP = "Klip",
}
